export default __webpack_public_path__ + "static/media/Sarabun-Light.0f087e83.ttf";